import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import dummyImg from '../assets/images/shared image.jfif'
import './SearchByLocation.css'
import "@fontsource/inter/400.css";
import { Container, Row, Col, Form, Card, Button, } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import bannerImage from '../assets/images/banner.png';
import residentialPlot from '../assets/images/residential-plots.jpg';
import { FaArrowRight } from 'react-icons/fa';


const Location = () => {
  const { location: initialLocation, category: initialCategory } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(initialCategory || '');
  const [selectedLocation, setSelectedLocation] = useState(initialLocation || '');
  const navigate = useNavigate();


  const properties = [
    {
      title: 'Luxury Villa in Hills',
      category: 'Villa',
      location: 'California',
      price: 1200000,
      image: dummyImg
    },
    {
      title: 'Modern Apartment',
      category: 'Apartment',
      location: 'New York',
      price: 850000,
      image: dummyImg
    },
    // add more...
  ];

  // Sample data for dropdowns
const categories = [
    'Residential Plots',
    'Commercial Plots',
    'Agricultural Land',
    'Industrial Plots'
  ];

  const locations = [
    'Miyapur',
    'Madhapur',
    'Hi-Tech City',
    'Gachibowli',
  ];
   const handleSearch = (e) => {
    e.preventDefault();
    if (!selectedLocation) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Selection',
        text: 'Please select location',
        confirmButtonText: 'OK',
        customClass: {
          title: 'swal-small-title',
          popup: 'swal-small-popup',
          htmlContainer: 'swal-small-text'
        }
      });
      return;
    }
    if (!selectedCategory) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Selection',
        text: 'Please select category',
        confirmButtonText: 'OK',
        customClass: {
          title: 'swal-small-title',
          popup: 'swal-small-popup',
          htmlContainer: 'swal-small-text'
        }
      });
      return;
    }
    navigate(`/${selectedLocation}/${selectedCategory}`);
  };


  return (

    <>
      <div className=' home-container1'>
        <div
          className="banner-section"
          style={{ backgroundImage: `url(${bannerImage})` }}
        >
          <div className="banner-overlay"></div>
          <div className="banner-content">
            <h1>Search Results</h1>
            <p className="breadcrumb-text">
              <span>{selectedLocation || initialLocation}</span> <span className="arrow">&rarr;</span> <span>{selectedCategory || initialCategory}</span>
            </p>
          </div>
        </div>
      </div>
      <Container style={{ padding: '20px', marginTop: '10px' }}>
        <Row className="justify-content-center dropdownSection">
          <Col lg={10}>
            <div className="property-search-box">
              <Form onSubmit={handleSearch}>
                <Row className="align-items-center">
                  <Col md={3} className="mb-3 mb-md-0">
                    <Form.Group controlId="searchTerm">
                      <Form.Control
                        type="text"
                        placeholder="What are you looking for?"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4} className="mb-3 mb-md-0">
                    <Form.Group controlId="location">
                      <Form.Select
                        value={selectedLocation}
                        className="custom-category-select"
                        onChange={(e) => setSelectedLocation(e.target.value)}
                      >
                        <option value="" disabled>Select Locations</option>
                        {locations.map((loc, index) => (
                          <option key={index} value={loc}>{loc}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4} className="mb-3 mb-md-0">
                    <Form.Group controlId="category">
                      <Form.Select
                        value={selectedCategory}
                        className="custom-category-select"
                        onChange={(e) => setSelectedCategory(e.target.value)}
                      >
                        <option value="" disabled>Select Categories</option>
                        {categories.map((cat, index) => (
                          <option key={index} value={cat}>{cat}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={1}>
                    <button type="submit" className="search-btn searchButton">
                      Search
                    </button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
      <Container style={{ padding: '20px', }}>
        <Row className='dropdownSection'>
          <p className='m-0 itemFound'>2 Items Found</p>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col sm={4}>
            <Card className='mainCard'>
              <Card.Img variant="top" className='imgCard' src={bannerImage} />
              <Card.Body>
                <Card.Title style={{fontWeight:600}}>Shashank's Plot</Card.Title>
                <Row>
                  <Col sm={6}>
                    <Card.Text>
                      <p className='m-0'>$1,960.00</p>
                      <p>   Hyderabad, Telangana</p>
                    </Card.Text>
                  </Col>
                  <Col sm={2}></Col>
                  <Col sm={4}>

                     <Link to="/GetDetailsByName" className="details-button">
                      Details <FaArrowRight className="arrow-icon" />
                    </Link>

                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={4}>
            <Card className='mainCard'>
              <Card.Img variant="top" className='imgCard' src={residentialPlot} />
              <Card.Body>
                <Card.Title style={{fontWeight:600}}>Shiva's Plot</Card.Title>
                <Row>
                  <Col sm={6}>
                    <Card.Text>
                      <p className='m-0'>$1,880.00</p>
                      <p>   Hyderabad, Telangana</p>
                    </Card.Text>
                  </Col>
                  <Col sm={2}></Col>
                  <Col sm={4}>
                    <Link to="/GetDetailsByName" className="details-button">
                      Details <FaArrowRight className="arrow-icon" />
                    </Link>

                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          {/* <Col sm={4}>4</Col> */}
        </Row>
      </Container>
    </>

  );
};

export default Location;
